export const getRemovebgCreditsQuery = `
  query GetRemovebgCredits($first: Int!, $skip: Int, $order: [Removebg_creditsOrder!]) {
    findRemovebgCredits(
      first: $first,
      skip: $skip,
      order: $order
    ) {
      count
      edges {
        node {
          objectId
          freeCreditsAmount
          paidCreditsAmount
          createdAt
          org_pointer {
            objectId
            nome
          }
        }
      }
    }
  }
`;

export const getActiveOrganizationsQuery = `
  query GetActiveOrganizations($first: Int!, $skip: Int, $where: OrganizzazioneWhereInput) {
    organizzaziones(
      first: $first,
      skip: $skip,
      where: $where
    ) {
      count
      edges {
        node {
          objectId
          nome
          stato
          tipo_istanza
        }
      }
    }
  }
`;

export const getRemovebgOrdersQuery = `
  query GetRemovebgOrders($first: Int!, $skip: Int, $order: [Removebg_ordersOrder!], $where: Removebg_ordersWhereInput) {
    findRemovebgOrders(
      first: $first,
      skip: $skip,
      order: $order,
      where: $where
    ) {
      count
      edges {
        node {
          objectId
          freeCreditsAmount
          paidCreditsAmount
          note
          paymentReference
          isPaid
          createdAt
          org_pointer {
            objectId
            nome
          }
        }
      }
    }
  }
`;